import Actividades from '@frontend/actividad/actividades.view.vue';
import AgregarActividadView from '@frontend/actividad/agregar-actividad.view.vue';
import DetalleActividadView from '@frontend/actividad/detalle-actividad.view.vue';
import ListaActividadesView from '@frontend/actividad/lista-actividades.view.vue';
import VisarActividadesView from '@frontend/actividad/visar-actividades.view.vue';
import AdminListaActividadesView from '@frontend/actividad/admin-lista-actividades.view.vue';
import AdminEditarActividadView from '@frontend/actividad/admin-editar-actividad.view.vue';
import AsistenteDeCargaView from '@frontend/actividad/asistente-de-carga.view.vue';

export const actividades = {
  path: '/actividades',
  name: 'Actividades',
  component: Actividades,
  redirect: '/actividades/lista',
  children: [
    {
      path: 'admin',
      name: 'AdminListaActividades',
      component: AdminListaActividadesView,
    },
    {
      path: 'admin/:id',
      name: 'AdminEditarActividad',
      component: AdminEditarActividadView,
    },
    {
      path: 'agregar',

      name: 'AgregarActividad',
      component: AgregarActividadView,
    },
    {
      path: ':id',

      name: 'DetalleActividad',
      component: DetalleActividadView,
    },
    {
      path: 'lista',

      name: 'ListaActividades',
      component: ListaActividadesView,
    },
    {
      path: 'asistente',
      name: 'AsistenteDeCarga',
      component: AsistenteDeCargaView,
    },
    {
      path: 'visar',

      name: 'VisarActividades',
      component: VisarActividadesView,
    },
  ],
};
